import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Layout from '../components/Layout';
import PageHero from '../components/PageHero';
import Button from '../components/ui/Button';
import { ArrowRight } from '../components/ui/Icons';
import usePageMeta from '../hooks/usePageMeta';

const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

const Popular = styled.nav`
  margin-top: 2.5rem;
  padding-bottom: var(--section-y);

  h2 {
    font-size: 1.125rem;
    margin-bottom: 0.75rem;
  }

  ul {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem 1.5rem;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  a {
    color: var(--text-2);
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  a:hover,
  a:focus-visible {
    color: var(--text-1);
  }
`;

const POPULAR_PAGES = [
  { to: '/services', label: 'Services' },
  { to: '/projects', label: 'Our work' },
  { to: '/blog', label: 'Blog' },
  { to: '/contact', label: 'Contact' },
];

const NotFound: React.FC = () => {
  usePageMeta({
    title: 'Page not found',
    description: 'This page is not on the CuttingEdge DevOps site. Start from the home page or see our work.',
    noindex: true,
  });

  return (
    <Layout navActive={false}>
      <PageHero
        eyebrow="404"
        title="We couldn't find that page."
        lead="The link may be old, or the page may have moved. Start from the home page or see our recent work."
      >
        <Actions>
          <Button to="/" size="lg">
            Go to the home page
          </Button>
          <Button to="/projects" variant="secondary" size="lg">
            See our work <ArrowRight />
          </Button>
        </Actions>
        <Popular aria-labelledby="popular-pages">
          <h2 id="popular-pages">Popular pages</h2>
          <ul>
            {POPULAR_PAGES.map((page) => (
              <li key={page.to}>
                <Link to={page.to}>{page.label}</Link>
              </li>
            ))}
          </ul>
        </Popular>
      </PageHero>
    </Layout>
  );
};

export default NotFound;
